import { useTranslation as useTranslationOriginal } from 'react-i18next';

export const useTranslation = () => {
    const { t, i18n } = useTranslationOriginal();
    const isRTL = i18n.language === 'ar';
    return { t, isRTL, i18n };
};
